import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-create-lead',
  templateUrl: './create-lead.component.html',
  styleUrls: ['./create-lead.component.css']
})
export class CreateLeadComponent implements OnInit {

  constructor(private leadService:ServiceService,private route: ActivatedRoute, private router: Router) { }
  isShownCustomer=false
  customer:any=[];
  Pagingflag=0
  CreateLeadShown=false
  NameAlert=""
  MobileAlert=""
  EmailAlert=""
  LnameAlert=""
  Contact2Alert="enter a valid mobile number"
  alert=""
  isChange=false
  //createUrl="http://192.241.151.66:5000/addContact"
  
  email:any=new FormControl('', [Validators.required, Validators.email]);
  mobile1:any=new FormControl('', [Validators.required, Validators.pattern("[0-9]{10}$")]);
  
  data={
    first_name:"",
    last_name:"",
    email:"",
    contact_1:"",
    contact_2:""
  }
  //--------function for shown the alert----------
  shown(){
    this.isChange=false
  }
  //---------check value changes in the text box----
  valuechange1(newValue1: any) {
    this.data.first_name=newValue1
    this.NameAlert=""
    }
    //---------check value changes in the text box----
   valuechange2(newValue1: any) {
    this.data.contact_1=newValue1
    this.MobileAlert=""
  }
  //---------check value changes in the text box----
  valuechange3(newValue1: any) {
    this.data.email=newValue1
    this.EmailAlert=""
  }
 
  //-------function for add a new lead--------
  AddLeads()
  {
    console.log("Contact2=",this.data.contact_2)
    if(this.data.first_name=="")
    {
      this.NameAlert="enter a name "
      
    }
    if(this.mobile1.invalid)
    {
      this.MobileAlert="enter a valid mobile number"
      
    }
    
    if (this.email.invalid)
    {
      this.EmailAlert="invalid email id"
      
    }
    if(this.data.first_name!="" && this.mobile1.valid && this.data.contact_1!="" && this.email.valid && this.data.email!="" )
    {
      
        this.leadService.CreateLead(this.data).subscribe((res) => {
        this.alert=res.message;
        console.log("alert=",this.alert)
       })
       this.data.first_name=""
      this.data.contact_1=""
      this.data.email=""
      this.data.last_name=""
      this.data.contact_2=""
     this.isChange=true
    }
  }

  ngOnInit(): void {
  }

}
